import type { EnemyDef } from '@nebulark/engine';

export const ENEMIES: Record<string, EnemyDef> = {
  'grunt-straight': {
    id: 'grunt-straight',
    archetype: 'straight',
    hp: 1,
    speed: 180,
    radius: 14,
    scoreValue: 50,
  },
  'weaver-sine': {
    id: 'weaver-sine',
    archetype: 'sine',
    hp: 2,
    speed: 120,
    radius: 16,
    scoreValue: 100,
    params: { amplitude: 80, frequency: 2 },
  },
  'sniper-aimed': {
    id: 'sniper-aimed',
    archetype: 'aimed',
    hp: 3,
    speed: 60,
    radius: 18,
    fireRateHz: 0.6,
    bulletSpeed: 260,
    scoreValue: 200,
  },
  swarmer: {
    id: 'swarmer',
    archetype: 'swarm',
    hp: 1,
    speed: 220,
    radius: 10,
    scoreValue: 75,
  },
  'snake-fighter': {
    id: 'snake-fighter',
    archetype: 'snake',
    hp: 2,
    speed: 60,
    radius: 12,
    scoreValue: 120,
  },
  'orbit-fighter': {
    id: 'orbit-fighter',
    archetype: 'orbit',
    hp: 3,
    speed: 60,
    radius: 13,
    scoreValue: 200,
    params: { amplitude: 68, frequency: 1.8 },
  },
};
